import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["src", "priority", "unoptimized", "placeholder", "quality", "resize", "fill"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import NextImage from 'next/image';
import React from 'react';
import { getImageLoader } from './helpers/get-image-loader';
import { shouldFillParentContainer } from './helpers/should-fill-parent-container';
import { upgradeImageProtocol } from './helpers/upgrade-image-protocol';
/**
 * This is a common type for all functions that will be used to load images.
 */

import { jsx as _jsx } from "react/jsx-runtime";

var getSvgPlaceholder = function getSvgPlaceholder(_ref) {
  var width = _ref.width,
      height = _ref.height,
      placeholder = _ref.placeholder;

  if (typeof placeholder === 'string') {
    return placeholder;
  }

  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width || '100%', "' height='").concat(height || '100%', "' viewBox='0 0 ").concat(width, " ").concat(height, "'%3E%3Crect fill='%23F2F2F2' width='").concat(width, "' height='").concat(height, "'/%3E%3C/svg%3E");
};

export var Image = function Image(props) {
  var src = props.src,
      _props$priority = props.priority,
      priority = _props$priority === void 0 ? false : _props$priority,
      _props$unoptimized = props.unoptimized,
      unoptimized = _props$unoptimized === void 0 ? false : _props$unoptimized,
      placeholder = props.placeholder,
      _props$quality = props.quality,
      quality = _props$quality === void 0 ? 75 : _props$quality,
      _resize = props.resize,
      _fill = props.fill,
      rest = _objectWithoutProperties(props, _excluded);

  var imageWithUpgradedProtocol = typeof src === 'string' ? upgradeImageProtocol(src) : src;
  var loader = getImageLoader(_objectSpread(_objectSpread({}, props), {}, {
    src: imageWithUpgradedProtocol
  }));
  var placeholderBlurDataURL = getSvgPlaceholder(props);
  return /*#__PURE__*/_jsx(NextImage
  /**
   * Only set the fill property if the width and height are not explicitly set
   */
  , _objectSpread({
    fill: shouldFillParentContainer(props),
    loader: loader,
    blurDataURL: placeholderBlurDataURL,
    placeholder: placeholder ? 'blur' : 'empty',
    priority: priority,
    quality: quality,
    src: imageWithUpgradedProtocol || placeholderBlurDataURL,
    unoptimized: unoptimized || !loader
  }, rest));
};